// extracted by mini-css-extract-plugin
export var link = "Footer-module--link--ixJIY";